import { render, staticRenderFns } from "./ControlSideBar.vue?vue&type=template&id=8c854be8"
import script from "./ControlSideBar.vue?vue&type=script&lang=js"
export * from "./ControlSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports